import { Constants } from '../../../../../../../constants/constants';
import { WidgetDataSource } from '../../../../../../../models';
import {
  Comparison,
  Widget,
  WidgetGroup,
} from '../../../../../../../providers/bridge-api/dashboard.service';
import { FieldService } from '../../../../../../../providers/storage-api/field.service';
import { CrosstabWidgetOptions } from '../../../../widget-crosstab/widget-crosstab.component';
import { AiInsightPayloadParams } from './widget-ai-insights-point-selection.service';
import { WidgetPointSelection } from './widget-point-selection';

export class CrosstabPointSelection extends WidgetPointSelection {
  override assemblePayloadFromSelection(
    selectedPoints: any[],
    widget: Widget<CrosstabWidgetOptions>,
    dataSource: WidgetDataSource,
    widgetGroup?: WidgetGroup,
    comparison?: Comparison
  ): AiInsightPayloadParams {
    const payload = super.assemblePayloadFromSelection(
      selectedPoints,
      widget,
      dataSource,
      widgetGroup,
      comparison
    );

    const assembleAnalyticItem = (analyticItem, subType) => {
      const resolvedAnalyticItem = FieldService.getFieldLongName(
        analyticItem?.replace(Constants.SECTION_PROPERTIES_PREFIX, '')
      );

      if (subType) {
        return `${subType} ${resolvedAnalyticItem}`;
      }
      return resolvedAnalyticItem;
    };

    for (let pointIdx = 0; pointIdx < selectedPoints.length; pointIdx++) {
      const point = selectedPoints[pointIdx];
      const bucket = payload.buckets[pointIdx];

      bucket.analytic_item_types = [
        assembleAnalyticItem(widget.payload.analyticItem, widget.payload.entityTypeFilter),
        assembleAnalyticItem(
          widget.payload.columnAnalyticItem,
          widget.payload.columnEntityTypeFilter
        ),
      ];
      bucket.analytic_item_values = [point.y, point.x];

      delete bucket.analytic_item_type;
      delete bucket.analytic_item_value;
    }

    return payload;
  }

  protected override fillWidgetQueryOptionsForWidget(
    widgetQueryOptions: any,
    widget: Widget<CrosstabWidgetOptions>
  ): void {
    widgetQueryOptions.parentAnalyticItem = widget.payload.columnAnalyticItem;
    widgetQueryOptions.parentSubType = widget.payload.columnEntityTypeFilter;
    widgetQueryOptions.parentIsMetadata =
      widget.payload.columnCustomFieldSelected || widget.payload.columnStandardFieldSelected;
    widgetQueryOptions.parentSectionPropertySelected = widget.payload.columnSectionPropertySelected;
    widgetQueryOptions.selectedSection = widget.payload.rowSelectedSections;
    widgetQueryOptions.parentSelectedSections = widget.payload.columnSelectedSections;
  }

  protected override fillWidgetQueryOptionsForPoint(widgetQueryOptions, point: any) {
    widgetQueryOptions.pointName = point.y;
    widgetQueryOptions.parentPointName = point.x;
    widgetQueryOptions.analyticItems = [
      'documents',
      'topics',
      'entities',
      'phrases',
      'themes',
      'taxonomy',
    ];

    if (widgetQueryOptions.analyticItem === 'taxonomy') {
      widgetQueryOptions.subType = undefined;
    }
    if (widgetQueryOptions.parentAnalyticItem === 'taxonomy') {
      widgetQueryOptions.parentSubType = undefined;
    }
  }
}
